import React from "react"
import { graphql } from "gatsby"

import { QueryFragments } from "../GraphQl/queryFragments"

import { BlogCard } from "../components/blog/blogCard"
import { BlogBanner } from "../components/blog/blogBanner"
import { BlogNav } from "../components/blog/blogNav"

const BlogCategory = ({ data, pageContext }) => {
  const posts = data.posts.edges || []
  return (
    <>
      <BlogBanner />
      <div className="grid grid-cols-14 mb-32 mt-16">
        <BlogNav />
        <div className="col-start-2 col-end-14 md:col-start-3 md:col-end-13 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-16">
          {posts && posts.map(item => <BlogCard {...item.node} />)}
        </div>
      </div>
    </>
  )
}

export default BlogCategory

export const pageQuery = graphql`
  query blogCategoryQuery($skip: Int!, $limit: Int!, $id: String!) {
    posts: allSanityPost(
      skip: $skip
      limit: $limit
      filter: { category: { elemMatch: { _id: { eq: $id } } } }
    ) {
      edges {
        node {
          ...BlogCardFields
        }
      }
    }
  }
`
